export default __webpack_public_path__ + "static/media/falcon.52d5d922.png";